import Vue from 'vue'
import VueRouter from 'vue-router'
import MesVerify from '../views/MesVerify'
import ImgVerify from '../views/ImgVerify'
import index from '../views/index'
import nameID from '../views/nameID'
import lotNames from '../views/lotNames'
import verifyFail from '../views/verifyFail'
import verifyIng from '../views/verifyIng'
import Confirm from '../views/confirm'
import Appeal from '../views/Appeal'
import Faq from '../views/Faq'
import App from '../App'
import MergeNameInfoByBank from '../views/mergeNameInfoByBank'
import ImgCode from '../components/ImgCode'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/MesVerify',
      name: 'MesVerify',
      component: MesVerify
    }, {
      path: '/ImgVerify',
      name: 'ImgVerify',
      component: ImgVerify
    }, {
      path: '/index',
      name: 'index',
      component: index
    }, {
      path: '/nameID',
      name: 'nameID',
      component: nameID
    }, {
      path: '/lotNames',
      name: 'lotNames',
      component: lotNames
    }, {
      path: '/verifyFail',
      name: 'verifyFail',
      component: verifyFail
    }, {
      path: '/verifyIng',
      name: 'verifyIng',
      component: verifyIng
    }, {
      path: '/Appeal',
      name: 'Appeal',
      component: Appeal
    }, {
      path: '/Confirm',
      name: 'Confirm',
      component: Confirm
    }, {
      path: '/Faq',
      name: 'Faq',
      component: Faq
    }, {
      path: '/',
      name: 'App',
      component: App
    },
    {
      path: '/MergeNameInfoByBank',
      name: 'MergeNameInfoByBank',
      component: MergeNameInfoByBank,
    },
    {
      path: '/ImgCode',
      name: 'ImgCode',
      component: ImgCode
    },
  ]
})
